import videojs from 'video.js';
import './slider';
import './videojs-stream-shopping.css';
import './button-toggle.js';
import './list-products.js';
import './button-toggle-list-products.js';
import { composeUI } from '../../js/compose-ui';

export default function streamShopping(options) {
  composeUI(this);

  this.ready(() => {
    const slider = addSlider(this, options);
    this.slideToProductCard = (productCardId) => {
      slider.slideToProductCard(productCardId);
    }
    this.el_.classList.add('vjs-stream-shopping');
    addButtonToggle(this, options);
    addListProductsAndButtonToggle(this, options);
    this.off('dblclick');
    this.tech().off('dblclick');
  });

  function addSlider(player, options) {
    return player.addChild(
      'StreamShoppingSlider',
      options,
      player.children_.length
    );
  }

  function addListProductsAndButtonToggle(player,  options) {
    const listProducts = player.addChild(
      'ListProducts',
      options,
      player.children_.length
    );
    player.addChild(
      'ButtonToggleListProducts',
      videojs.mergeOptions(
        options,
        {toggleVisibilityListProducts: listProducts.toggleVisibility.bind(listProducts)}
      ),
      player.children_.length
    );
    player.el().classList.add('vjs-list-products-component');
  }

  function addButtonToggle(player, options) {
    const controlBar = player.getChild('controlBar');
    if (controlBar === undefined) {
      return;
    }
    const customControlSpacer = controlBar.getChild('customControlSpacer');
    if (customControlSpacer === undefined) {
      return;
    }
    const index = controlBar.children_.indexOf(customControlSpacer) + 1;
    controlBar.addChild('ButtonToggleStreamShopping', options, index);
  }
}

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
registerPlugin('streamShopping', streamShopping);
